/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

import type { Utilities } from 'core/domains';

import { snakeToCamelCase } from './snake-to-camel-case';

/**
 * Converts the keys of the object to camelCase
 */
export function keysToCamelCase(data: Utilities.PlainObject) {
  const str = JSON.stringify(data);
  const regex = new RegExp(/"(\w+)":/, 'g');
  const result = str.replace(regex, (_, ...args) => `"${snakeToCamelCase(args[0])}":`);

  return JSON.parse(result);
}
